<template>
  <div class="h-14 flex gap-1">
    <div
      v-for="(item, index) in gallery"
      :key="index"
      :title="item.title"
      class="relative rounded-sm p-1 bg-primary w-12 h-14 ltr:-ml-1 rtl:-mr-1 z-0"
    >
      <div v-if="item.isVideo" class="w-full h-full">
        <video
          class="w-full h-full object-cover rounded-sm border border-secondary relative bg-transparent z-10"
          :src="item.src"
          :controls="false"
          :preload="false"
        />
        <Icon
          name="video"
          size="xl"
          class="absolute text-primary bg-primary p-0.5 rounded-full top-[calc(50%-10px)] left-[calc(50%-10px)] z-0"
        />
      </div>
      <img
        v-else
        class="w-full h-full object-cover rounded-sm"
        :src="item.src"
      />
      <button
        class="w-5 h-5 rounded-full bg-quaternary p-[3px] absolute -top-[3px] ltr:-right-[3px] rtl:-left-[3px] hover:bg-tertiary flex items-center align-center shadow-xs group z-20"
        @click="deleteMedia(index)"
      >
        <Icon name="close" class="fg-quaternary group-hover:text-primary" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { toRaw, computed } from "vue";
import { Icon } from "@/SharedComponents/Icon";

const emit = defineEmits(["deleteMedia"]);
const props = defineProps({
  media: {
    type: Array,
  },
});

const gallery = computed(() => {
  return toRaw(props.media).map((el) => {
    const isVideo = el.file?.type?.includes("video");

    return {
      src: el.src,
      file: el.file,
      isVideo,
    };
  });
});

const deleteMedia = (index) => {
  emit("deleteMedia", index);
};
</script>
